import { defineComponent as _defineComponent } from 'vue'
import { biClick } from '@tencent/fit-bi-sdk';
import { FriendsInfo, FriendsInfoStatus } from '@tencent/wphk-act-base-cgi';
import { AnnouncementIcon } from '@tencent/wphk-icon-vue';
import { FitButton, NavTabs, NavTabsInfo } from '@tencent/wphk-ui';
import { computed, ref } from 'vue-demi';
import { isEmptyNickName } from '../../business';
import { useActInfo } from '../../hooks/use-act-info';
import { i18n } from '../../i18n';
import { C2CSharerAction, NavTabId } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invite-list',
  emits: ['onShare'],
  setup(__props, { emit: emits }) {



const { phase2FriendsInfo, maxInviteCount, successInviteCount, allCouponDiscount } = useActInfo();

const isFinishInvite = computed(() => successInviteCount.value >= maxInviteCount.value);

function formatNickName(list: FriendsInfo[]): FriendsInfo[] {
  let idx = 0;
  return list
    .slice()
    .reverse()
    .map(item => ({
      ...item,
      nickName: isEmptyNickName(item.nickName) ? i18n('好友') + (idx += 1) : item.nickName,
    }))
    .reverse();
}

function formatFriendsInfoList(obj) {
  return Object.entries(obj).reduce((result, [key, value]) => {
    // eslint-disable-next-line no-param-reassign
    result[key] = formatNickName(value as FriendsInfo[]);
    return result;
  }, {});
}

const friendsInfoList = computed(() => {
  const list: { [key in NavTabId]: FriendsInfo[] } = {
    [NavTabId.success]: [],
    [NavTabId.ing]: [],
    [NavTabId.failed]: [],
  };
  (phase2FriendsInfo.value || []).forEach((element) => {
    if (element.state === FriendsInfoStatus.getAward) {
      list[NavTabId.success].push(element);
    } else if (element.state === FriendsInfoStatus.onWayAward) {
      list[NavTabId.ing].push(element);
    } else {
      list[NavTabId.failed].push(element);
    }
  });
  return formatFriendsInfoList(list);
});

const tabId = ref(NavTabId.success);

const navTabs: NavTabsInfo[] = [
  { name: i18n('已獲獎賞'), id: NavTabId.success },
  { name: i18n('獎賞喺路上'), id: NavTabId.ing },
  { name: i18n('未獲得獎賞'), id: NavTabId.failed },
];

function navChange(tab) {
  biClick('c2c.invite_list_tab', { ftab: tab.id });
  tabId.value = tab.id;
}

function onShare() {
  emits('onShare', C2CSharerAction.share);
}

return { __sfc: true,emits, phase2FriendsInfo, maxInviteCount, successInviteCount, allCouponDiscount, isFinishInvite, formatNickName, formatFriendsInfoList, friendsInfoList, tabId, navTabs, navChange, onShare, FriendsInfoStatus, AnnouncementIcon, FitButton, NavTabs, i18n, NavTabId }
}

})